import moment from "moment";
import { matchPath, useLocation } from "react-router-dom";
import { useOrderFlow } from "../../../../OrderFlow/OrderFlowProvider/OrderFlowContext";
import { getCurrentMealFromCart } from "../../../utils/getCurrentMealFromCart";
import { getOrderFlowRecipeAssignments } from "../../../utils/getOrderFlowRecipeAssignments";
/**
 * Returns information about the current recipe's assignments.
 *
 * @param recipe
 * @param programMealId
 * @returns
 */
export const useItemDetailCustomize = (recipe, programMealId) => {
    const { store } = useOrderFlow();
    const location = useLocation();
    const isOrderFlow = matchPath({ path: "/:sku/OrderFlow" }, location.pathname);
    const currentMeal = getCurrentMealFromCart(store.cart.meals, moment(store.cart.selectedDay), programMealId);
    const orderFlowRecipeAssignments = getOrderFlowRecipeAssignments(currentMeal, recipe, programMealId, moment(store.cart.selectedDay));
    const myMealsRecipeAssignments = recipe === null || recipe === void 0 ? void 0 : recipe.Assignments;
    const currentRecipeAssignments = !!isOrderFlow ? orderFlowRecipeAssignments : myMealsRecipeAssignments;
    return {
        currentRecipeAssignments,
    };
};
